import React from 'react';
import {
  Text as JssText,
  RichText as JssRichText,
  withDatasourceCheck,
} from '@sitecore-jss/sitecore-jss-nextjs';
import { ListItem } from '@greystar/designsystem';
import { IconTextCardItemProps } from '@greystar/ui';

const IconTextCardItem = (props: IconTextCardItemProps) => {
  const { icon, heading, description } = props.fields;

  return (
    <ListItem
      icon={icon?.value ?? 'Profile'}
      heading={<JssText field={heading} />}
      descriptionItems={[<JssRichText key="description" field={description} />]}
      isRTE={true}
    />
  );
};

export default withDatasourceCheck()<IconTextCardItemProps>(IconTextCardItem);
